import Popover from '@deprecated-ui/common/Popover';
import CommentAnalytics from 'features/stream/analytics/CommentAnalytics';
import PopoverCommentSetting from 'global/StreamCompose/CommentSetting/CommentSettingPopover';
import { COMMENT_SETTING_LIST } from 'global/StreamCompose/constants';
import { useEffect, useState } from 'react';
import { StreamCommenterType } from '../../../../@types/stream';

interface PopoverChangeCommenterProps {
  visible: boolean;
  hasMention: boolean;
  defaultCommenterType: StreamCommenterType;
  popoverId: string;
  onChange: (type: string, label: string) => void;
  onCancel: (val: boolean) => void;
}

function PopoverChangeCommenter({
  visible,
  hasMention,
  defaultCommenterType,
  popoverId,
  onChange,
  onCancel,
}: PopoverChangeCommenterProps) {
  const defaultCommenter = COMMENT_SETTING_LIST.find(
    (comment) => comment.type === defaultCommenterType,
  );
  const [commenter, setCommenter] = useState(defaultCommenter);

  const onChangeCommenter = (data) => {
    setCommenter(data);
    onChange(data.type, data.label);
    CommentAnalytics.Action.ChangeComment();
  };

  const commentTypeWithMention =
    hasMention || defaultCommenterType === 'COMMENTER_TYPE_MENTION';

  const commentTypeList = COMMENT_SETTING_LIST;

  useEffect(() => {
    const defaultComment = COMMENT_SETTING_LIST.find(
      (comment) => comment.type === defaultCommenterType,
    );
    setCommenter(defaultComment);
  }, [defaultCommenterType]);

  return (
    <Popover
      trigger="contextMenu"
      placement="bottomRight"
      overlayStyle={{ minWidth: '145px' }}
      content={() => (
        <PopoverCommentSetting
          commentSettingList={commentTypeList}
          commenter={commenter}
          onChangeCommenter={onChangeCommenter}
        />
      )}
      visible={visible}
      onVisibleChange={onCancel}
      getPopupContainer={() => document.getElementById(popoverId)}
      zIndex={20}
    >
      <div style={{ width: '1px', position: 'absolute', right: 0, top: 10 }} />
    </Popover>
  );
}

export default PopoverChangeCommenter;
